<img *ngIf="!isImageBroken" class="image-container" src="{{ _src }}" loading="lazy" decoding="async" (error)="setBrokenImage()" [style.height.px]="_height" [style.width.px]="width" [style.border]="borderStyle" />
<div *ngIf="isImageBroken" class="image-container" [style.height.px]="_height" [style.width.px]="width" [style.line-height.px]="_height" [style.font-size.px]="fontSize" [style.border]="borderStyle">
  {{ _altText }}
</div>
